// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PresenterInfo_wrapper__EZwV2"};